import React, { useState } from "react";
import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/entry.nostyle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from "@fortawesome/pro-light-svg-icons";
import { GlobalStyle, StyledDiv } from "./styles";

export const StyledDateRangePicker = (props) => {
  const [value, onChange] = useState([
    props.startDate || new Date(new Date().getFullYear(), new Date().getMonth()),
    props.endDate || new Date()
  ]);

  const handleSelect = (value) => {
    onChange(value);
    const startDate = value[0];
    const endDate = value[1];
    props.onDateRangeSelect({ startDate, endDate });
  };

  return (
    <React.Fragment>
      <GlobalStyle />
      <StyledDiv>
        <DateRangePicker
          onChange={handleSelect}
          value={value}
          clearIcon={null}
          calendarIcon={<FontAwesomeIcon icon={faCalendar} color="#006c9c" className="calendar-icon" />}
          calendarType="US"
          format="MM/dd/yyyy"
        />
      </StyledDiv>
    </React.Fragment>
  );
}
